module.exports = __webpack_public_path__ + "media/img/help_center/Student_Profile_07-cb4e84289c54b40f0f2f368d51ac5ad2.jpg";